/* eslint-disable no-console */
import { Injectable } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';

import { LogMessage } from '../log-message.model';
import { LogAppender } from './log-appender.service';

@Injectable()
export class CloudAppender implements LogAppender {
  constructor(private aff: Functions) {}

  async write(logMessage: LogMessage): Promise<void> {
    await httpsCallable(
      this.aff,
      'log',
    )({
      ...logMessage,
      exception: logMessage.exception
        ? {
            name: logMessage.exception.name,
            stack: logMessage.exception.stack,
            message: logMessage.exception.message,
          }
        : undefined,
    });
  }
}
